var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tree-box model", style: _vm.curNopadding },
    [
      _vm.treeTitle
        ? _c("hoverTitle", { attrs: { treeTitle: _vm.treeTitle } })
        : _vm._e(),
      _vm._v(" "),
      _c("el-input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.treeNodeFilter,
            expression: "treeNodeFilter"
          }
        ],
        attrs: { placeholder: "输入关键字进行过滤" },
        model: {
          value: _vm.filterText,
          callback: function($$v) {
            _vm.filterText = $$v
          },
          expression: "filterText"
        }
      }),
      _vm._v(" "),
      _vm.treeList.length
        ? _c("el-tree", {
            ref: "tree",
            staticClass: "deteleDialog",
            style: { height: _vm.treeHeight },
            attrs: {
              data: _vm.treeList,
              "node-key": _vm.curTreeKey,
              props: _vm.defaultProps,
              "show-checkbox": _vm.showCheckbox,
              "current-node-key": _vm.curCheckedKey,
              "highlight-current": "",
              "default-expand-all": "",
              "expand-on-click-node": false,
              "filter-node-method": _vm.filterNode,
              "check-strictly": _vm.checkStrictly,
              "check-on-click-node": true
            },
            on: {
              "node-expand": _vm.treeExpand,
              "node-click": _vm.clickNodeFn,
              "check-change": _vm.handleCheckChange
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var node = ref.node
                    var data = ref.data
                    return _c(
                      "div",
                      {
                        staticClass: "custom-tree-node",
                        class: data == _vm.checkNode ? "checkBgc" : "",
                        attrs: { id: node.id },
                        on: {
                          mouseover: function($event) {
                            _vm.ifEditMenu ? _vm.mouseoverTree(data) : ""
                          },
                          mouseleave: function($event) {
                            _vm.ifEditMenu ? _vm.mouseleaveTree(data) : ""
                          }
                        }
                      },
                      [
                        _vm.showIcon &&
                        data.children &&
                        data.children.length > 0
                          ? _c("img", {
                              staticClass: "icon folder",
                              attrs: { alt: "" }
                            })
                          : _vm.showIcon && _vm.treeIcon && _vm.treeIcon != ""
                          ? _c("img", {
                              staticClass: "icon",
                              staticStyle: { width: "0.13rem" },
                              attrs: { src: _vm.treeIcon, alt: "" }
                            })
                          : _vm.showIcon
                          ? _c("img", {
                              staticClass: "icon file",
                              staticStyle: { width: "0.13rem" },
                              attrs: { alt: "" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "each-node",
                            style: { width: _vm.nodeWidth },
                            attrs: { title: data[_vm.labelname] }
                          },
                          [
                            _c("span", { staticClass: "each-tree-title" }, [
                              _vm._v(_vm._s(data[_vm.labelname]))
                            ]),
                            _vm._v(" "),
                            data[_vm.countName] != null
                              ? _c("span", { staticClass: "each-tree-title" }, [
                                  _vm._v(
                                    "(" + _vm._s(data[_vm.countName]) + ")"
                                  )
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: data.ifEdit,
                                expression: "data.ifEdit"
                              }
                            ],
                            attrs: { placement: "bottom" },
                            on: {
                              command: function(command) {
                                _vm.handleDropdown(command, data)
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _c("i", {
                                staticClass: "el-icon-more",
                                staticStyle: { transform: "rotate(90deg)" }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "addCurrent" } },
                                  [_vm._v("新增")]
                                ),
                                _vm._v(" "),
                                data[_vm.labelname] != "全部"
                                  ? _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "editMenu" } },
                                      [_vm._v("编辑")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                data[_vm.labelname] != "全部"
                                  ? _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "delete" } },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }
                }
              ],
              null,
              false,
              2535088812
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e76b169", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e76b169","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXTree/tree.vue
// module id = 425
// module chunks = 0